import { getStore } from '@/store'
import { isSameDate, isStandardDeliveryDate } from '@/utils/deliveryDate'
import { TransportationTypes } from '@/utils/transportTypes'

export async function setDeliveryDate (
  date: string,
  shipmentId: string,
  fallbackToFirstAvailable = false
): Promise<void> {
  const selectedDateIso = date && new Date(date).toISOString().split('.')[0] + 'Z'
  const exceptions = getStore()?.state.deliveryDates.availableExceptions
  const shiptos = getStore()?.state.catalog.shipTos
  const availableDates = getStore()?.state.deliveryDates.availableDays

  // Preserve the explicitly selected delivery date when passed in.
  // Only fallback to the first available date when explicitly allowed.
  if (availableDates?.includes(selectedDateIso)) {
    localStorage.setItem('deliveryDate', date)
  } else if (fallbackToFirstAvailable && availableDates && availableDates.length > 0) {
    const firstDate = new Date(availableDates[0])
    const formattedDate = firstDate.toISOString().split('T')[0]
    localStorage.setItem('deliveryDate', formattedDate)
  }

  const usedDate = localStorage.getItem('deliveryDate') || ''

  if (shiptos?.length === 0) {
    await getStore()?.dispatch('catalog/FETCH_SHIP_TO', { ship_to_id: localStorage.getItem('shipToId') }, { root: true })
  }
  const isDeliveryDateFallback = getStore()?.state.deliveryDates.isDeliveryDateFallback
  const isGigyaFallback = getStore()?.state.auth.isGigyaFallback
  localStorage.setItem(
    'exceptiondate', isDeliveryDateFallback ? '0' : isGigyaFallback ? Number(exceptions?.some((exception) => isSameDate(exception.scheduledDate, usedDate))).toString() : Number(exceptions?.some((exception) => isSameDate(exception.scheduledDate, usedDate))).toString()
  )

  const filteredDeliveryDates = getStore()?.state.deliveryDates.filteredDeliveryDates || []
  if (isDeliveryDateFallback) {
    localStorage.setItem(
      'standardDeliveryDate',
      Number(isStandardDeliveryDate(usedDate, shipmentId, getStore()?.state.catalog.shipTos)).toString()
    )
  } else if (shipmentId === TransportationTypes.UNFILTERED || shipmentId === TransportationTypes.TANK) {
    const isoDate = new Date(usedDate).toISOString().split('.')[0] + 'Z'
    const standardDeliveryDate = filteredDeliveryDates.includes(isoDate) ? '1' : '0'
    localStorage.setItem('standardDeliveryDate', standardDeliveryDate)
  } else {
    localStorage.setItem(
      'standardDeliveryDate',
      Number(isStandardDeliveryDate(usedDate, shipmentId, getStore()?.state.catalog.shipTos)).toString()
    )
  }
}

export function getShipToOptions (): { label: string; shipToId: string; description: string }[] {
  const { permissionSchema = [] } = getStore()?.state.auth.user || {}
  return permissionSchema
    .filter((permission: any) =>
      permission.rpDetails.some(
        (role: any) => role.permission.includes('Catalogue') && permission.shipToStatus === 'APPROVED'
      )
    )
    .map((permission: any) => ({
      label: permission.shipToName,
      shipToId: permission.shipToId,
      description: permission?.shipToAddress
    }))
}
